(function() {

var _ = ui._;
var load_count = 0, titles;

ui.loadAdd(onLoad);

function onLoad() {
  if(!w.product_data || !ui.productGet) {
    if(load_count < 10)
      setTimeout(onLoad, 16);
    load_count++
    return;
  }

  var ident = '/search';
  if(location.pathname.substr(-ident.length) !== ident)
    autocomplete();
}

function filter(text) {
  function exists(title) {
    for(var i = 0; i < count; i++)
      if(title.indexOf(words[i]) === -1) {
        return false;
        break;
      }
    return true;
  }
  if(!titles) {
    titles = {};
    for(var i in product_data.products) {
      product = ui.productGet(i);
      titles[i] = product.title.toLowerCase() + (product.model ? (' ' + product.model).toLowerCase() : '');
    }
  }
  var product_ids = [], words = text.toLowerCase().split(' '), count = words.length, title;
  for(var i in titles)
    if(exists(titles[i]))
      product_ids.push(i);
  return product_ids;
}

function autocomplete($input) {
  function onKeyDown(event) {
    function addActive(count) {
      if(!$items.el.children.length)
        return;
      if($items.el.children[currentFocus])
        $items.el.children[currentFocus].classList.remove('autocomplete-active');
      currentFocus += count;
      if(currentFocus >= $items.el.children.length)
        currentFocus = 0;
      else
      if(currentFocus < 0)
        currentFocus = $items.el.children.length - 1;
      $items.el.children[currentFocus].classList.add('autocomplete-active');
    }

    var code = event.keyCode;
    if([13, 38, 40].indexOf(code) === -1)
      return;
    if($items.hasClass('hidden'))
      onInput();
    event.preventDefault();
    if(code === 40/*down*/)
      addActive(1);
    else
    if(code === 38/*up*/)
      addActive(-1);
    else
    if(code === 13/*enter*/) {
      if($items.el.children.length && (currentFocus > -1))
        $items.el.children[currentFocus].click();
      else
      if($input.el.value)
        location.href = ui.url.search + encodeURIComponent($input.el.value);
    }
  }

  function hideItems() {
    $items.toggleClass('hidden', true);
  }

  function hideItems2(event) {
    if(!event.target.contains($input.el))
      hideItems();
  }

  function showItems(product_ids) {
    $items.toggleClass('hidden', false);
    currentFocus = -1;
    for(var i = $items.el.children.length - 2; i >= 0 ; i--)
      $items.el.children[i].remove();

    var product, products = [];
    for(var i = 0; i < product_ids.length; i++) {
      product = ui.productGet(product_ids[i], true);
      if(product.instock == 1)
        products.unshift(product);
      else
        products.push(product);
    }
    for(var i = 0, item; i < products.length; i++) {
      if(i === 6)
        break;
      product = products[i];
      $items.insert(
        _('a').attr('class', 'autocomplete-item', 'href', product.href).append(
          _('img').attr('src', product.image),
          _('span').text(product.title)
        ),
        $itemLast
      );
    }
    $itemLast.attr('href', ui.url.search + encodeURIComponent($input.el.value));
    $count.text(products.length);
  }

  function onInput() {
    var text = $input.el.value.trim();
    if(text.length >= 3)
      showItems(filter(text));
    else
      hideItems();
  }

  var $input = _('#f-search');
  $input.on('focus', onInput).on('input', onInput);
  _(d).on('click', hideItems2);
  var currentFocus = -1;
  $input.on('keydown', onKeyDown);
  var $items = $input.parent().$elByClass('autocomplete-items');
  var $itemLast = $items.$elByClass('autocomplete-item-more');
  var $count = $itemLast.$elByClass('autocomplete-item-count');
}

})();